var React = require('react');

function IconExclamation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 20C3.104 20 4 20.896 4 22C4 23.104 3.104 24 2 24C0.896 24 0 23.104 0 22C0 20.896 0.896 20 2 20ZM2 0C2.55228 0 3 0.447715 3 1V16C3 16.5523 2.55228 17 2 17C1.44772 17 1 16.5523 1 16V1C1 0.447715 1.44772 0 2 0Z","fill":"#CF000F"}));
}

IconExclamation.defaultProps = {"width":"4","height":"24","viewBox":"0 0 4 24","fill":"none"};

module.exports = IconExclamation;

IconExclamation.default = IconExclamation;
